var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 352 198",
    style: {
      enableBackground: "new 0 0 352 198"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EEEEED;}\n\t.st1{fill:#969696;}\n\t.st2{fill:#EEEDEE;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 352,
    height: 198
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.5,136.2H117.3c-3.8,0-6.8-3.1-6.8-6.8V64.5c0-3.8,3.1-6.8,6.8-6.8h109.3c3.8,0,6.8,3.1,6.8,6.8v64.8 C233.4,133.1,230.3,136.2,226.5,136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.8,133.4H120c-3.4,0-6.2-2.8-6.2-6.2V66.6c0-3.4,2.8-6.2,6.2-6.2h103.7c3.4,0,6.2,2.8,6.2,6.2v60.5 C230,130.6,227.2,133.4,223.8,133.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172,125c-14.7,0-29.4,0-44.2,0c-0.7,0-1.7,0.4-2-0.4c-0.4-0.8,0.6-1.3,1-1.8c5.9-8.1,11.8-16.1,17.8-24.1 c2.4-3.3,5.2-3.2,7.7,0c2,2.6,4,5.3,5.9,8c0.9,1.3,1.5,1.5,2.6,0c5.9-8.1,11.8-16.1,17.7-24.2c3.2-4.4,5.8-4.4,9.1,0 c9.8,13.3,19.6,26.6,29.4,39.9c0.5,0.7,1.6,1.4,1.1,2.3c-0.4,0.7-1.5,0.3-2.3,0.3C201.1,125,186.6,125,172,125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.5,67.9c4.5,0,7.9,3.5,7.8,7.9c-0.1,4.2-3.7,7.6-7.9,7.6c-4.3,0-7.7-3.5-7.8-7.7 C127.5,71.3,131.1,67.9,135.5,67.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/companyLogo.71d9f64ef1b95a078cdf7f5fc754ab29.svg";
export { ForwardRef as ReactComponent };